let items = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");

for (const item of items) {
    let timeout; // Variable to handle delay for closing the menu

    item.addEventListener("mouseenter", () => {
        clearTimeout(timeout); // Clear any existing timeout
        item.setAttribute("open", true); // Open the dropdown
    });

    item.addEventListener("mouseleave", (event) => {
        // Add a slight delay before closing the dropdown
        timeout = setTimeout(() => {
            // Check if the mouse is not hovering over the dropdown menu
            if (!item.contains(event.relatedTarget)) {
                item.removeAttribute("open");
            }
        }, 500); // Adjust the delay as needed
    });

    const dropdown = item.querySelector("ul");
    if (dropdown) {
        dropdown.addEventListener("mouseenter", () => {
            clearTimeout(timeout); // Clear the timeout when hovering over the dropdown
        });

        dropdown.addEventListener("mouseleave", (event) => {
            // Close the dropdown when the mouse leaves the dropdown area
            if (!dropdown.contains(event.relatedTarget)) {
                item.removeAttribute("open");
            }
        });
    }
}